import { useState, useEffect } from 'react';
import styles from './Css/Banner.module.css';

const Banner = ({
  desktopImagePath, // Image for desktop devices
  mobileImagePath,  // Image for mobile devices
  altText
}) => {
  // State to track if the device is mobile
  const [isMobile, setIsMobile] = useState(false);

  // Function to check if the window width is mobile size
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  // Set up event listener on component mount
  useEffect(() => {
    // Check initially
    checkIsMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkIsMobile);
    
    // Clean up listener on unmount
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return (
    <div className={styles.banner}>
      <div className={styles.imageContainer}>
        <img
          src={isMobile ? mobileImagePath : desktopImagePath}
          alt={altText}
          className={styles.image}
        />
      </div>
    </div>
  );
};

export default Banner;